import { AdminVendorsData } from '@models/interfaces';

export const VENDORS_DEFAULT_VALUE: AdminVendorsData = {
  id: '',
  name: '',
  email: '',
};
